export default __webpack_public_path__ + "static/media/nntv.7d588e66.jpeg";